import { combineReducers } from 'redux';
import loader from './loader'
import subscriptionTeam from './subscriptionTeam';
import myProfile from './myProfile';
import classes from './classes';
import tubGallery from './tubGallery';
import auth from './auth';
import invitation from './invitation';
import session from './session';
import tubinbox from './tubinbox';
import analytics from './analytics'
import game from './game';
import dataToPersist from './dataToPersist';
import curriculum from './curriculum'

const reducersList =  combineReducers({
    loader,
    auth,
    subscriptionTeam,
    myProfile,
    classes,
    invitation,
    tubGallery,
    session,
    tubinbox,
    game,
    analytics,
    curriculum,
    dataToPersist,
})

export const reducers = (state, action) => {
    if (action.type === "LOGOUT") {
      state = undefined;
    }
  
    return reducersList(state, action)
}